// extracted by mini-css-extract-plugin
export default {"grid":"CodexGrid_grid__spph1"};